export default __webpack_public_path__ + "images/c8135b776475c74fab05dc55fecbb047.svg";